import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { TestExecutionStatus } from '@flowqa/shared';

export type CloneExecutionSortDirection = 'asc' | 'desc';
export type CloneExecutionSortKey =
  | 'testName'
  | 'suiteName'
  | 'status'
  | 'durationMs'
  | 'timestamp'
  | 'runNumber'
  | 'runId';

export const cloneExecutionDefaultSortKey: CloneExecutionSortKey = 'timestamp';
export const cloneExecutionDefaultSortDirection: CloneExecutionSortDirection = 'desc';

export const cloneExecutionSortOptions: Array<{
  key: CloneExecutionSortKey;
  label: string;
}> = [
  { key: 'testName', label: 'Test Name' },
  { key: 'suiteName', label: 'Suite Name' },
  { key: 'status', label: 'Status' },
  { key: 'durationMs', label: 'Duration' },
  { key: 'timestamp', label: 'Executed' },
  { key: 'runNumber', label: 'Run' },
  { key: 'runId', label: 'Details' },
];

export const cloneExecutionSortFieldMap: Record<CloneExecutionSortKey, string> = {
  testName: 'testName',
  suiteName: 'suiteName',
  status: 'status',
  durationMs: 'durationMs',
  timestamp: 'timestamp',
  runNumber: 'runNumber',
  runId: 'runId',
};

export const cloneExecutionColumnOptions: Array<{
  field: string;
  label: string;
  mandatory?: boolean;
}> = [
  { field: 'name', label: 'Test', mandatory: true },
  { field: 'status', label: 'Status' },
  { field: 'runNumber', label: 'Run' },
  { field: 'runId', label: 'Details' },
];

export const cloneExecutionStatusOptions: Array<{
  value: TestExecutionStatus;
  label: string;
}> = [
  { value: 'passed', label: 'Passed' },
  { value: 'failed', label: 'Failed' },
  { value: 'errored', label: 'Errored' },
  { value: 'skipped', label: 'Skipped' },
];

export const cloneExecutionDefaultColumnVisibilityModel: GridColumnVisibilityModel = {
  name: true,
  status: true,
  runNumber: true,
  runId: true,
};
